import { render, staticRenderFns } from "./CoverWebNewsForm.vue?vue&type=template&id=e2694bee&"
import script from "./CoverWebNewsForm.vue?vue&type=script&lang=js&"
export * from "./CoverWebNewsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports